export default "/images/77d08ff89bca98b1b78d386418cede13.png";